import {
    FETCH_VENDOR_DATA,
    fetchVendorDataSuccess,
    fetchVendorDataFailure,
} from './action';
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS,HTTP_RESPONSE_TYPE_BLOB,HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import {VENDOR_API} from '../../config';


export function* fetchVendorData(action) {

    let requestUrl = `${VENDOR_API}/vendorData/extract?startDate=${action.data.fromDate}&endDate=${action.data.toDate}`;
    try {
        const vendorData = yield call(request, requestUrl, { data: '', method:'GET',headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_BLOB  });
        yield put(fetchVendorDataSuccess(vendorData.data));
    } catch (err) {   
            yield put(fetchVendorDataFailure(err.response ));
    }
}


export function* fetchVendorTrackingData() {
    yield takeLatest(FETCH_VENDOR_DATA, fetchVendorData);
}